import { CLIENT } from "components/Budgeting2023/options/margin/FormulasTab"
import {
  LOADING,
  SET_INITIAL_RIGHT_FOOTER_DATA,
  SET_RIGHT_FOOTER,
  SET_MARGIN_PERCENT,
  SET_UNIT_PRICE,
  SET_MARGIN_EURO,
  SET_TOTAL_PRICE,
  SET_FORMULA,
  SET_PARTIDA,
  SET_QUANTITY,
  SET_PARTIDA_VALUE,
  SET_INITIAL_VALUES,
  SET_COST,
  SET_TOTAL_COST,
  SET_PRICE_REDUCED,
  SET_PRICE_PREREDUCED,
  SET_COST_REDUCTION,
  SET_EURO_REDUCED,
  SET_TOTAL_REDUCED,
  SET_DISCOUNT_PERCENTAGE,
  SET_DISCOUNT_AMOUNT,
  SET_UNIT_PRICE_WITH_DISCOUNT,
  SET_TOTAL_PRICE_WITH_DISCOUNT,
} from "context/types"

export const initialModalPartidaState = {
  leftGridContent: {
    cost: 0,
    totalCost: 0,
    quantity: 0,
    costReduction: 0,
    priceReduced: 0,
    pricePrereduced: 0,
    euroReduced: 0,
    totalReduced: 0,
  },
  rightFooter: {
    marginPercent: 0,
    unitPrice: 0,
    marginEuro: 0,
    totalPrice: 0,
    discountPercentage: 0,
    discountAmount: 0,
    unitPriceWithDiscount: 0,
    totalPriceWithDiscount: 0,
  },
  loading: false,
  formula: CLIENT,
  partida: {},
}

export const modalPartidaReducer = (state, action) => {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: action.payload,
      }

    case SET_PARTIDA:
      return {
        ...state,
        partida: action.payload,
      }

    case SET_PARTIDA_VALUE:
      return {
        ...state,
        partida: {
          [action.payload.field]: action.payload.value,
        },
      }

    case SET_FORMULA:
      return {
        ...state,
        formula: action.payload,
      }

    case SET_INITIAL_RIGHT_FOOTER_DATA:
      return {
        ...state,
        rightFooter: {
          ...state.rightFooter,
          ...action.payload.rightFooter,
        },
      }

    case SET_INITIAL_VALUES:
      return {
        ...state,
        leftGridContent: {
          ...state.leftGridContent,
          cost: action.payload.cost,
          totalCost: action.payload.totalCost,
          quantity: action.payload.quantity,
          costReduction: action.payload.costReduction,
          priceReduced: action.payload.priceReduced,
          euroReduced: action.payload.euroReduced,
          totalReduced: action.payload.totalReduced,
        },
      }

    case SET_RIGHT_FOOTER:
      return {
        ...state,
        rightFooter: { ...state.rightFooter, ...action.payload },
      }

    case SET_MARGIN_PERCENT:
      return {
        ...state,
        rightFooter: {
          ...state.rightFooter,
          marginPercent: action.payload.marginPercent,
        },
      }
    case SET_UNIT_PRICE:
      return {
        ...state,
        rightFooter: {
          ...state.rightFooter,
          unitPrice: action.payload.unitPrice,
        },
      }
    case SET_MARGIN_EURO:
      return {
        ...state,
        rightFooter: {
          ...state.rightFooter,
          marginEuro: action.payload.marginEuro,
        },
      }
    case SET_TOTAL_PRICE:
      return {
        ...state,
        rightFooter: {
          ...state.rightFooter,
          totalPrice: action.payload.totalPrice,
        },
      }

    case SET_QUANTITY:
      return {
        ...state,
        leftGridContent: {
          ...state.leftGridContent,
          quantity: action.payload.quantity,
        },
        // partida: {
        //   ...state.partida,
        //   quantity: action.payload.quantity,
        // },
      }

    case SET_COST:
      return {
        ...state,
        leftGridContent: {
          ...state.leftGridContent,
          cost: action.payload.cost,
        },
      }
    case SET_TOTAL_COST:
      return {
        ...state,
        leftGridContent: {
          ...state.leftGridContent,
          totalCost: action.payload.totalCost,
        },
      }

    case SET_PRICE_REDUCED:
      return {
        ...state,
        leftGridContent: {
          ...state.leftGridContent,
          priceReduced: action.payload.priceReduced,
        },
      }

    case SET_PRICE_PREREDUCED:
      return {
        ...state,
        leftGridContent: {
          ...state.leftGridContent,
          pricePrereduced: action.payload.pricePrereduced,
        },
      }

    case SET_COST_REDUCTION:
      return {
        ...state,
        leftGridContent: {
          ...state.leftGridContent,
          costReduction: action.payload.costReduction,
        },
      }

    case SET_EURO_REDUCED:
      return {
        ...state,
        leftGridContent: {
          ...state.leftGridContent,
          euroReduced: action.payload.euroReduced,
        },
      }

    case SET_TOTAL_REDUCED:
      return {
        ...state,
        leftGridContent: {
          ...state.leftGridContent,
          totalReduced: action.payload.totalReduced,
        },
      }

    case SET_DISCOUNT_PERCENTAGE:
      return {
        ...state,
        rightFooter: {
          ...state.rightFooter,
          discountPercentage: action.payload.discountPercentage,
        },
      }

    case SET_DISCOUNT_AMOUNT:
      return {
        ...state,
        rightFooter: {
          ...state.rightFooter,
          discountAmount: action.payload.discountAmount,
        },
      }

    case SET_UNIT_PRICE_WITH_DISCOUNT:
      return {
        ...state,
        rightFooter: {
          ...state.rightFooter,
          unitPriceWithDiscount: action.payload.unitPriceWithDiscount,
        },
      }

    case SET_TOTAL_PRICE_WITH_DISCOUNT:
      return {
        ...state,
        rightFooter: {
          ...state.rightFooter,
          totalPriceWithDiscount: action.payload.totalPriceWithDiscount,
        },
      }

    default:
      return state
  }
}
